import B2BAPI from './B2BAPI'

export const getCampaigns = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign', { // GET http://localhost:9090/b2b/api/v1/campaign?b2bAccountId=b88bb12d-c0ca-4050-ab93-574143a2ae8f
      params: {
        ...params
      }
    })
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createCampaign = async (payload) => {
  // {
  //   name: 'my first campaign',
  //   importerCountryCode: 'CL',
  //   currentCountryCode: 'TR',
  //   hsCodes: ['080810'],
  //   productName: null,
  //   b2bAccountId: 'b9e1322d-a339-43c2-b9b9-cd875187e61c',
  //   emailSettings: {
  //     emailUserName: 'xxxx@gmail.com',
  //     emailPassword: 'xxxx',
  //     smtpHostName: 'smtp.gmail.com',
  //     smtpPort: 587,
  //     transportStrategy: 'SMTP_TLS',
  //     rxHostName: 'imap.gmail.com',
  //     rxPort: 993,
  //     rxProtocol: 'IMAPS',
  //     inboxFolderName: 'INBOX'
  //   }
  // }
  try {
    const response = await B2BAPI.post('/campaign', payload)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getFirms = async (params) => { // GET http://localhost:9090/b2b/api/v1/firms?b2bCampaignId=c256adfa-0d0c-4399-be4b-d281c20238da
  try {
    const response = await B2BAPI.get('/firms', {
      params: {
        ...params
      }
    })
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getTemplates = async (params) => { // GET http://localhost:9090/b2b/api/v1/email-template?b2bAccountId=b88bb12d-c0ca-4050-ab93-574143a2ae8f
  try {
    const response = await B2BAPI.get('/email-template', {
      params: {
        ...params
      }
    })
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const sendEmail = async (payload) => {
  // {
  //   b2bCampaignId: 'c256adfa-0d0c-4399-be4b-d281c20238da',
  //   templateId: 'ba6b7f75-fcc2-4f54-8356-92e8a8e244b2',
  //   subject: 'B2B DENEME TEST 6',
  //   templateParameters: {},
  //   firmList: [
  //     {
  //       name: 'WALMART CHILE S.A.',
  //       web: 'https://www.walmartchile.cl',
  //       emailList: [
  //         'contacto@walmartchile.cl'
  //       ]
  //     }
  //   ]
  // }
  try {
    const response = await B2BAPI.post('/send-email', payload)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getMessages = async (params) => { // GET http://localhost:9090/b2b/api/v1/campaign/messages?b2bCampaignId=c256adfa-0d0c-4399-be4b-d281c20238da
  try {
    const response = await B2BAPI.get('/campaign/messages', {
      params: {
        ...params
      }
    })
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const receive = async (params) => { // GET http://localhost:9090/b2b/api/v1/campaign/messages?b2bCampaignId=c256adfa-0d0c-4399-be4b-d281c20238da
  try {
    const response = await B2BAPI.get('/receive', {
      params: {
        ...params
      }
    })
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateUser = async (userId, payload) => {
  try {
    const response = await B2BAPI.put(`/account/${userId}`, payload)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createTemplate = async (payload) => {
  try {
    const response = await B2BAPI.post('/email-template', payload)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateTemplate = async (templateId, payload) => {
  try {
    const response = await B2BAPI.put(`/email-template/${templateId}`, payload)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteTemplate = async (templateId) => {
  try {
    const response = await B2BAPI.delete(`/email-template/${templateId}`)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}
